











































import { localDateFormat } from '@/utils/dateHelpers';
import Vue, { PropType } from 'vue';
export default Vue.extend({
  props: {
    value: {
      type: [Date, String]
    },
    showCurrent: {
      type: [Boolean, String] as PropType<boolean | string>,
      default: () => true
    },
    format: {
      type: String,
      default: () => 'DD MMM YYYY'
    },
    stringifyDate: {
      type: Boolean
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },

    allowedDates: {
      type: Function as PropType<(val: string) => boolean | null>,
      default: null
    }
  },
  data() {
    return {
      open: false,
      lazyValue: new Date(this.value) as Date | null | string
    };
  },
  computed: {
    internalValue: {
      get(): string | Date | null {
        return this.lazyValue;
      },
      set(val: string | Date | null) {
        this.$emit('input', val);
        this.lazyValue = val;
      }
    },

    formatedDate(): string {
      if (this.internalValue == null) {
        return '';
      }
      return localDateFormat(this.internalValue, this.format);
    }
  },
  watch: {
    value: {
      handler(val: any) {
        if (!val) {
          this.lazyValue = null;
        } else {
          this.lazyValue = val;
        }
      },
      immediate: true
    }
  },
  methods: {
    clearValue() {
      if (this.$listeners['click:clear']) {
        this.$emit('click:clear');
      } else {
        this.internalValue = null;
      }
    },

    selectedDay(date: Date) {
      this.internalValue = this.stringifyDate
        ? localDateFormat(date, this.format)
        : date;
      this.open = false;
    }
  }
});
